import React, { Component } from "react";
import {
  ActivityIndicator,
  Image,
  Dimensions,
  Text,
  TouchableOpacity,
  View,
  Platform,
} from "react-native";
import AsyncStorage from '@react-native-community/async-storage';
import Timeline from "react-native-timeline-flatlist";
import _ from "lodash";

import Header from "../components/Header";
import ParallaxScrollView from "react-native-parallax-scroll-view";
import AutoHeightImage from "react-native-auto-height-image";
import { NavigationEvents } from "react-navigation";
import staticColors from "../constants/staticColors";

import {
  getBaseUrl,
  getConsultation,
  getMedical,
  setConsultation,
  setMedical
} from "../helpers/storage";
import moment from "moment";
import { connect } from "react-redux";
import TimelineSection from "../components/TimelineSection";
import PatientAvatarWithDetail from "../components/PatientAvatarWithDetail";
import PatientDetailMore from "../components/PatientDetailMore";
import TimelineItem from "../components/TimelineItem";
import fonts from "../constants/fonts";

class CustomerProfileScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: "",
      fullName: "",
      cardNumber: "",
      organization: "",
      status: "",
      class: "",
      age: 0,
      gender: "m",
      birthdate: new Date(),
      phone: "",
      email: "",
      id: "",
      dependenceStatus: "",
      activeConsultation: null,
      medical: null,
      historiesTotal: 0,
      historiesData: [],
      isLoading: true,
      symptompsCheckEnabled: false,
      doctorCheckEnabled: false,
      symptomsCheckUrl: ''
    };
  }

  _onPress = () => {
    if (this.state.medical) {
      if (this.state.activeConsultation) {
        this.props.navigation.navigate("Waiting", {
          patientId: this.state.id,
          activeConsultation: this.state.activeConsultation
        });
      } else {
        // temporary disable dependence status check

        // if (this.state.dependenceStatus === "0") {
        //   this.props.navigation.navigate("Symptoms", {
        //     patientId: this.state.id,
        //     policyNumber: null
        //   });
        // } else if (this.state.dependenceStatus === "1") {
        this.props.navigation.navigate("ask", {
          patientId: this.state.id,
          firstName: this.state.firstName
        });
        // }
      }
    } else {
      this.props.navigation.navigate("Medical", {
        birthdate: this.state.birthdate,
        cardNumber: this.state.cardNumber,
        fullName: this.state.fullName,
        gender: this.state.gender,
        age: this.state.age,
        height: null,
        weight: null
      });
    }
  };

  onMedicalCheckPress = () => {
    const { symptomsCheckUrl, id } = this.state;
    this.props.navigation.navigate("MedicalCheck", {
      url: symptomsCheckUrl,
      patientId: id
    });
  }

  checkLaunchStatus() {
    if (this.props.introSlides.length > 0) {
      this.props.navigation.navigate("intro");
    }
  }

  async fetchProfile() {
    setConsultation(null);

    const token = this.props.token;

    const rp = fetch(getBaseUrl() + "profile/me", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const bb = fetch(getBaseUrl() + "consultations/history", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const response = await rp;
    const rb = await bb;

    const json = await response.json();
    const jb = await rb.json();

    const histories = [];

    let lastDate;

    _.each(jb["data"], item => {
      const n = moment(item["created_at"]);

      const date = n.format("D MMM YYYY");

      if (lastDate !== date) {
        histories.push({
          type: "section",
          date: n.toDate(),
          icon: require("../assets/round_access_time_white_18dp.png")
        });

        lastDate = date;
      }

      histories.push({
        type: "single",
        doctor: {
          avatar: {
            uri: item["doctor_photo"]
          },
          name: item["doctor_name"],
          position: item["doctor_specialities"]
        },
        createdAt: n.toDate(),
        description: item["trx_summary"]
      });
    });
    const activeConsultation = json["data"]["active_consultation"];

    setConsultation(activeConsultation);

    setMedical(json["data"]["patient_height"], json["data"]["patient_weight"]);

    const age = json["data"]["patient_age"];
    // to handle if age is null, then set age = null. otherwise, age might be 0.
    const roundedAge = age === null || age === undefined ? null : Math.floor(Number(age));

    const symptompsCheckEnabled = json["data"]["config"]["is_symptoms_check_enabled"];
    let doctorCheckEnabled = json["data"]["config"]["is_check_doctor_enabled"];

    if (!symptompsCheckEnabled && !doctorCheckEnabled) {
      doctorCheckEnabled = true;
    }

    this.setState({
      historiesData: histories,
      historiesTotal: jb["total"],
      firstName: json["data"]["patient_f_name"],
      fullName:
        json["data"]["patient_f_name"] + " " + json["data"]["patient_l_name"],
      cardNumber: json["data"]["patient_card_number"],
      organization: json["data"]["patient_organization"],
      status: json["data"]["patient_vip_status"] ? "VIP" : "General",
      class: json["data"]["patient_class"],
      age: roundedAge,
      gender: json["data"]["patient_gender"],
      birthdate: moment(json["data"]["patient_dob"]).toDate(),
      phone: json["data"]["patient_phone"],
      email: json["data"]["patient_email"],
      id: json["data"]["id"],
      dependenceStatus: json["data"]["dependence_status"],
      activeConsultation: getConsultation(),
      medical: getMedical(),
      isLoading: false,
      symptompsCheckEnabled,
      doctorCheckEnabled,
      symptomsCheckUrl: json["data"]["config"]["symptoms_check_url"]
    });

    if (this.props.screenProps.intent) {
      if (
        this.props.screenProps.intent.action === "text_message" &&
        json["data"]["active_consultation"]
      ) {
        this.props.navigation.navigate("Waiting", {
          patientId: this.state.id,
          activeConsultation: this.state.activeConsultation
        });
      }
    } else if (json["data"]["transaction_to_post_assess"]) {
      this.props.navigation.navigate("PostAssessment", {
        transaction: {
          doctor: {
            avatarUrl:
              json["data"]["transaction_to_post_assess"]["doctor"][
              "doctor_photo"
              ],
            fullName:
              json["data"]["transaction_to_post_assess"]["doctor"][
              "doctor_f_name"
              ] +
              " " +
              json["data"]["transaction_to_post_assess"]["doctor"][
              "doctor_l_name"
              ]
          },
          startedAt:
            json["data"]["transaction_to_post_assess"][
            "consultation_chat_started_at"
            ],
          summary: json["data"]["transaction_to_post_assess"]["trx_summary"]
        }
      });
    }

    // check for previous active consultation on local storage
    const prevConsultationData = await AsyncStorage.getItem('active_consultation');
    if (prevConsultationData) {
      const prevConsultation = JSON.parse(prevConsultationData);

      // check prev with current active consultation
      const isPrevConsultationActive = activeConsultation ? (prevConsultation.trx_id === activeConsultation.trx_id &&
        prevConsultation.room_id === activeConsultation.room_id) : false;
      if (!isPrevConsultationActive) {

        // transfer to rating page if previous consulation is not the same as current active
        this.props.navigation.navigate("Rating", {
          transactionId: prevConsultation.trx_id,
          agentAvatar: prevConsultation.avatar_url,
          agentName: prevConsultation.username,
          agentSpecialities: prevConsultation.email
        });
      }

    }
  }

  componentDidMount() {
    this.checkLaunchStatus();

    this.promise = this.fetchProfile();
  }

  render() {
    if (this.state.isLoading) {
      return (
        <View
          style={{
            flex: 1,
            backgroundColor: this.props.themeColors.primary,
            justifyContent: "center"
          }}
        >
          <ActivityIndicator size="large" color="#fff" />
        </View>
      );
    }

    let t;

    if (this.state.historiesTotal > 0) {
      t = (
        <Timeline
          innerCircle="icon"
          circleColor={this.props.themeColors.lighterPrimary}
          lineColor={this.props.themeColors.primary}
          data={this.state.historiesData}
          detailContainerStyle={{ marginTop: -13, marginBottom: 13 }}
          listViewContainerStyle={{ marginLeft: 12, marginRight: 32 }}
          renderDetail={(rowData, sectionID, rowID) => {
            if (rowData.type === "section") {
              return <TimelineSection date={rowData.date} />;
            } else {
              return (
                <TimelineItem
                  createdAt={rowData.createdAt}
                  doctor={{
                    avatarUrl: rowData.doctor.avatar.uri,
                    specialities: rowData.doctor.position,
                    fullName: rowData.doctor.name
                  }}
                  summary={rowData.description || ""}
                />
              );
            }
          }}
          showTime={false}
        />
      );
    } else {
      t = null;
    }

    return (
      <ParallaxScrollView
        ref={ref => {
          this.scrollRef = ref;
        }}
        backgroundColor={this.props.themeColors.primary}
        parallaxHeaderHeight={500}
        renderForeground={() => (
          <View>
            <Header
              onPress={() => {
                this.props.screenProps.onClose();
              }}
              position="start"
              text="Tutup"
              theme="light"
            />
            <View
              style={{
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <View style={{ paddingTop: 36 }}>
                <AutoHeightImage
                  source={require("../assets/intro-3.png")}
                  width={Dimensions.get("window").width - 80}
                />
              </View>
              {
                this.state.symptompsCheckEnabled ? (
                  <TouchableOpacity onPress={this.onMedicalCheckPress} style={{ marginBottom: 16 }}>
                    <View
                      style={{
                        borderRadius: 30,
                        backgroundColor: staticColors.forestFern
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 20,
                          ...fonts.bold,
                          color: "#FFF",
                          width: 250,
                          textAlign: 'center',
                          paddingVertical: 16
                        }}
                      >
                        PERIKSA GEJALA
                      </Text>
                    </View>
                  </TouchableOpacity>
                ) : null
              }
              {
                this.state.doctorCheckEnabled ? (
                  <TouchableOpacity onPress={this._onPress}>
                    <View
                      style={{
                        borderRadius: 30,
                        backgroundColor: this.props.themeColors.darkestPrimary
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 20,
                          ...fonts.bold,
                          color: "#FFF",
                          width: 250,
                          textAlign: 'center',
                          paddingVertical: 16
                        }}
                      >
                        {this.state.activeConsultation
                          ? "LANJUT KONSULTASI"
                          : "TANYA DOKTER"}
                      </Text>
                    </View>
                  </TouchableOpacity>
                ) : null
              }
            </View>
          </View>
        )}
      >
        <View style={{ backgroundColor: this.props.themeColors.primary }}>
          <NavigationEvents
            onDidFocus={payload => {
              const consultation = getConsultation();
              const medical = getMedical();

              this.setState({
                activeConsultation: consultation
                  ? Object.assign({}, consultation)
                  : null,
                medical: medical ? Object.assign({}, medical) : null
              });
            }}
          />
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              padding: 20
            }}
          >
            <PatientAvatarWithDetail
              cardNumber={this.state.cardNumber}
              fullName={this.state.fullName}
              gender={this.state.gender}
            />
            <TouchableOpacity
              style={{ marginStart: 20 }}
              onPress={() => this.scrollRef.scrollTo({ x: 0, y: 500 })}
            >
              <Image
                source={require("../assets/baseline_keyboard_arrow_up_white_18dp.png")}
              />
            </TouchableOpacity>
          </View>
          <View
            style={{
              backgroundColor: "#FFF",
              borderTopEndRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40,
              borderTopStartRadius:
                Platform.OS === "android" && Platform.Version <= 26 ? 0 : 40
            }}
          >
            <View style={{ padding: 30, paddingTop: 15 }}>
              <View
                style={{
                  width: 64,
                  height: 6,
                  borderRadius: 3,
                  marginBottom: 15,
                  opacity: 0.5,
                  backgroundColor: "#808080",
                  alignSelf: "center"
                }}
              />

              <PatientDetailMore
                onEditPress={() => {
                  this.props.navigation.navigate("Medical", {
                    birthdate: this.state.birthdate,
                    cardNumber: this.state.cardNumber,
                    fullName: this.state.fullName,
                    gender: this.state.gender,
                    height: this.state.medical
                      ? this.state.medical.height
                      : null,
                    weight: this.state.medical
                      ? this.state.medical.weight
                      : null
                  });
                }}
                class={this.state.class}
                gender={this.state.gender}
                height={this.state.medical ? this.state.medical.height : null}
                organization={this.state.organization}
                weight={this.state.medical ? this.state.medical.weight : null}
                age={this.state.age}
              />
            </View>
            <View
              style={{
                backgroundColor: "#F1F1F1",
                height: 1,
                width: "100%",
                marginBottom: 30
              }}
            />
            <Text
              style={{
                fontSize: 20,
                ...fonts.bold,
                color: this.props.themeColors.darkestPrimary,
                alignSelf: "center"
              }}
            >
              RIWAYAT KONSULTASI
            </Text>
            <Text
              style={{
                fontSize: 15,
                ...fonts.regular,
                color: this.props.themeColors.darkerPrimary,
                alignSelf: "center",
                marginBottom: 30
              }}
            >
              {this.state.historiesTotal} Konsultasi
            </Text>
            {t}
          </View>
        </View>
      </ParallaxScrollView>
    );
  }
}

export default connect(state => ({
  introSlides: state.introSlides,
  themeColors: state.themeColors,
  token: state.token
}))(CustomerProfileScreen);
